import { Injectable } from '@angular/core';
import { TranslocoService, getBrowserLang } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root',
})
export class TranslocoLangDetectorService {
  private static readonly KEYCLOAK_LOCALE_APPLIED_KEY = 'keycloakLocaleApplied';

  constructor(private translocoService: TranslocoService) {}

  setBrowserLangIfNotSelected() {
    const selectedLang = this.getSelectedLang();
    if (selectedLang) {
      return;
    }

    const browserLang = getBrowserLang();
    const availableLanguages = this.translocoService.getAvailableLangs() as string[];

    if (!availableLanguages.includes(browserLang!)) {
      return;
    }

    this.translocoService.setActiveLang(browserLang!);
  }

  setKeycloakLocaleIfNeeded(locale: string | undefined) {
    if (!locale || sessionStorage.getItem(TranslocoLangDetectorService.KEYCLOAK_LOCALE_APPLIED_KEY)) {
      return;
    }

    const availableLanguages = this.translocoService.getAvailableLangs() as string[];
    if (availableLanguages.includes(locale)) {
      this.translocoService.setActiveLang(locale);
    }

    sessionStorage.setItem(TranslocoLangDetectorService.KEYCLOAK_LOCALE_APPLIED_KEY, 'true');
  }

  clearKeycloakLocale() {
    sessionStorage.removeItem(TranslocoLangDetectorService.KEYCLOAK_LOCALE_APPLIED_KEY);
  }

  private getSelectedLang(): string | null {
    return localStorage.getItem('translocoLang') || null;
  }
}
